<template>

  <div>
    <div class="va-row">
      <div class="flex md12 xs12">

        <div class="form-group">
          <div class="input-group">
            <input
              :name="name"
              v-model="textValue"
              v-validate="'required'"
              @input="onChangeInternal"
              required title=""/>
            <i
              class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa fa-check valid-icon icon-right input-icon"></i>
            <label class="control-label"></label><i class="bar"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'date-cell',

  data: function () {
    return {
      textValue: this.rowData[this.name]
    }
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },

    name: {
      type: String
    },

    onChange: {
      type: Function,
      default: () => {
      }
    }
  },

  mounted: function () {
  },

  methods: {
    onChangeInternal: function () {
      this.onChange({
        type: 'text',
        name: this.name,
        value: this.textValue,
        id: this.rowData.id
      })
    }
  }
}

</script>

<style scoped>

</style>
